import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.xm};
  padding: ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.md};
  background-color: ${theme.colors.neutral.white};
  margin-bottom: ${theme.spacing.md};

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    margin-top: 0;
  }
`

export const Row = styled.div`
  display: flex;
  align-items: center;
`

export const ReturnButton = styled.button`
  border: none;
  outline: none;
  margin-right: ${theme.spacing.xm};
  width: 30px;
  height: 30px;
  background-color: transparent;
`

export const TitleRow = styled(Row)`
  flex-wrap: wrap;
  gap: ${theme.spacing.xm};
  justify-content: space-between;
`

export const InfoRow = styled(Row)`
  margin-left: 50px;
  gap: ${theme.spacing.lg};
  flex-wrap: wrap;
`

export const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
`

export const MaterialName = styled.h5`
  margin: 0;
  color: ${theme.colors.neutral.high};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.sm};
  font-family: ${theme.typography.family.bold};
  display: flex;
  flex-direction: column;

  & > small {
    font-weight: ${theme.typography.weight.xsm};
    font-size: ${theme.typography.sizes.xs};
    font-family: ${theme.typography.family.primary};
  }
`

export const OrderNumber = styled.span`
  margin: 0;
  color: ${theme.colors.neutral.medium};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.bold};
  line-height: ${theme.typography.lineHeight.sm};
  justify-self: flex-end;

  strong {
    color: ${theme.colors.neutral.high};
    font-size: ${theme.typography.sizes.sm};
  }
`

export const InfoTitle = styled.span`
  margin: 0;
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes['2xs']};
  line-height: ${theme.typography.lineHeight.md};
  font-family: ${theme.typography.family.primary};
`

export const Subtitle = styled.span`
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.primary};
  line-height: ${theme.typography.lineHeight.sm};
  span {
    font-weight: ${theme.typography.weight.lg};
  }
`

export const ValueRow = styled.div`
  color: ${theme.colors.neutral.high};
`
export const Value = styled.span`
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.xs};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.md};
  line-height: ${theme.typography.lineHeight.sm};
`
export const Discount = styled.span`
  vertical-align: 2px;
  font-size: ${theme.typography.sizes.xs};
  color: ${theme.colors.alert.success.dark};
  font-weight: ${theme.typography.weight.xsm};
`

export const PricesRow = styled(Row)`
  gap: ${theme.spacing.xs};
  justify-content: space-between;
`

export const PricesCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const Divider = styled.div`
  width: 1px;
  height: 60px;
  background-color: ${theme.colors.neutral.lighthover};

  @media screen and (max-width: 600px) {
    display: none;
  }
`
